export default __webpack_public_path__ + "static/media/referenceImagesIcon.1263bfe5.svg";